import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
const tenantSlider = {
    _swiperTenantObj: '',
    
    init() {
       
    },
    
      
   enableSwiper () {
    this._swiperTenantObj = new Swiper($('.jsSwiper.jsTenant')[0], {
      slidesPerView: 1,
      loop: true,
      autoplay:true,
      spaceBetween: 30,

      breakpoints: {
          768: {
              slidesPerView: 1,
          },

      },
      pagination: {
        el: '.swiper-pagination',
        clickable: 'true',
    },
      modules: [Navigation, Pagination,Autoplay],
  });
},
  

}
export default tenantSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_tenant-swiper.js